module.exports = "https://cdn.dashboard.gifty.nl/5734/images/timer.png?c5b2978d4e5abb08df32210ea966734e";